import { useEffect, useRef, useState } from 'react'
import TimerIcon from 'src/icons/timer.webp'
import styles from './styles.module.scss'
import { useTimer } from 'src/lib/useTimer'

const TOTAL_SECONDS = 14 * 60
const REAL_DURATION = 10

export const CountdownTimer = () => {
    const { isRunning, stopTimer } = useTimer()
    const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS)
    const animationFrameRef = useRef<number | null>(null)
    const startTimeRef = useRef<number | null>(null)

    useEffect(() => {
        if (!isRunning) {
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current)
            }
            return
        }

        startTimeRef.current = performance.now()

        const tick = (now: number) => {
            if (!startTimeRef.current) return

            const realElapsed = (now - startTimeRef.current) / 1000
            const virtualElapsed = (realElapsed / REAL_DURATION) * TOTAL_SECONDS
            const remaining = Math.max(0, TOTAL_SECONDS - virtualElapsed)

            setTimeLeft(Math.floor(remaining))

            if (remaining <= 0) {
                stopTimer()
                return
            }

            animationFrameRef.current = requestAnimationFrame(tick)
        }

        animationFrameRef.current = requestAnimationFrame(tick)

        return () => {
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current)
            }
        }
    }, [isRunning, stopTimer])

    const formatTime = (seconds: number) => {
        const m = Math.floor(seconds / 60)
        const s = seconds % 60
        return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    }

    return (
        <div className={styles.timer}>
            <img src={TimerIcon} alt="Timer" className={styles.icon} />
            <span className={styles.text}>{formatTime(timeLeft)}</span>
        </div>
    )
}
